<template>
  <div :class="['content flex-column', programStyle]" v-if="pillarDetails">
    <div class="dealer-top" v-if="trackerInfo && trackerInfo.length > 0">
      <div class="trackers flex-column">
        <Tracker :trackerInfo="trackerInfo" />
      </div>
    </div>
    <div class="bottom flex-column">
      <div class="sticky-container flex-column">
        <Periods />
        <div class="warning-banner" v-if="periodMessages && checkPeriodMessages">
          <div v-for="message in periodMessages" class="warning-text" :key="message.id">
            <img v-if="message.icon === 'Stop'" src="@/assets/new/stop_white.png" />
            <img v-if="message.icon === 'Calendar'" src="@/assets/new/calendar_white.png" />
            <img v-if="message.icon === 'Yield'" src="@/assets/new/warning_white.png" />
            <span>{{ message.globalMessage }}</span>
          </div>
        </div>
        <div class="warning-banner" v-if="entityPeriodMessages && checkEntityPeriodMessages">
          <div class="warning-text" v-for="message in entityPeriodMessages" :key="message.id">
            <img v-if="message.icon === 'Stop'" src="@/assets/new/stop_white.png" />
            <img v-if="message.icon === 'Calendar'" src="@/assets/new/calendar_white.png" />
            <img v-if="message.icon === 'Yield'" src="@/assets/new/warning_white.png" />
            <span>{{ message.globalMessage }}</span>
          </div>
        </div>
        <div class="status-info flex-column">
          <div class="title">{{ $t('current-pillar-status') }}</div>
          <div class="description-container">
            <div class="description subtitle" v-for="pillar in pillarDetails" :key="pillar.pillarId">
              <div class="Performance" v-if="pillar.pillarIconSet === 'CFAFE Performance'">
                <Performance :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Training" v-else-if="pillar.pillarIconSet === 'CFAFE Training'">
                <Training :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Process" v-else-if="pillar.pillarIconSet === 'CFAFE Process'">
                <Process :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Facilities" v-else-if="pillar.pillarIconSet === 'CFAFE Facility'">
                <Facilities :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="EmployeeSurvey" v-else-if="pillar.pillarIconSet === 'CFAFE Survey'">
                <EmployeeSurvey :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div v-else class="Process"><Process :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}</div>
            </div>
          </div>
        </div>
      </div>
      <VueHtml2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        filename="dealer-info"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="100%"
        @progress="onProgress($event)"
        @hasDownloaded="hasDownloaded($event)"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <div class="detail-info flex-column">
            <div class="pdf-header">
              <div class="flex-column">
                <span class="title">{{ selectedDealer.dealerName }} </span>
                <span>{{ programBreadcrumb }}</span>
              </div>
              <div class="right flex-column">
                <div>
                  <span
                    >BC <span>: {{ selectedDealer.entity }} | </span></span
                  >
                  <span
                    >{{ $t('dealer-code') }} <span>: {{ selectedDealer.entity }} | </span></span
                  >
                  <span
                    >{{ $t('sales-district') }}<span>: {{ selectedDealer.salesDistrict }} | </span></span
                  >
                  <span
                    >{{ $t('service-district') }} <span>: {{ selectedDealer.serviceDistrict }} | </span></span
                  >
                  <span
                    >{{ $t('sales-group') }} <span>: {{ selectedDealer.groupSize }}</span></span
                  >
                </div>
              </div>
            </div>
            <div class="header">
              <div class="title">{{ $t('pillar-details') }}</div>
            </div>
            <div class="bottom-content flex-column" v-if="pillarDetails">
              <div class="pillar html2pdf__page-break pdf" v-for="pillar in pillarDetails" :key="pillar.pillarId">
                <div class="pillar-header subtitle">
                  <div class="Performance-pdf" v-if="pillar.pillarIconSet === 'CFAFE Performance'">
                    <Performance :class="pillar.pillarStatus" /><span>{{ pillar.pillarTitle }} </span>
                  </div>
                  <div class="Training" v-else-if="pillar.pillarIconSet === 'CFAFE Training'">
                    <Training :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
                  </div>
                  <div class="Process" v-else-if="pillar.pillarIconSet === 'CFAFE Process'">
                    <Process :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
                  </div>
                  <div class="Facilities" v-else-if="pillar.pillarIconSet === 'CFAFE Facility'">
                    <Facilities :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
                  </div>
                  <div class="EmployeeSurvey" v-else-if="pillar.pillarIconSet === 'CFAFE Survey'">
                    <EmployeeSurvey :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
                  </div>
                  <div class="Process" v-else><Process :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}</div>
                </div>
                <div class="pillar-details flex-column" v-if="pillar.show">
                  <div class="pillar-row" v-for="row in pillar.rows" :key="row.key">
                    <div class="pillar-title">{{ row.pillarRowTitle }}</div>
                    <div class="dial-container" v-for="dialRow in row.dials" :key="dialRow.key">
                      <div
                        class="smmt"
                        @click="selectDial(dialRow)"
                        v-if="dialRow.dialTypeId === 'SMMT' || dialRow.dialTypeId === 'FDMT'"
                      >
                        <IconProgress
                          v-if="dialRow.smmtProgress"
                          :progress="dialRow.smmtProgress"
                          :targets="dialRow.smmtTargets"
                          :color="dialRow.dialColor"
                        />
                        <div class="circle" v-if="!dialRow.smmtProgress"></div>
                        <div class="smmtInner-pdf" v-if="dialRow.dialResultText">
                          {{ dialRow.dialResultText }}
                        </div>
                      </div>
                      <div
                        v-else-if="dialRow.dialResultText !== 'EMPTY' && dialRow.dialName !== 'OR'"
                        :class="['circle', dialRow.dialColor]"
                        @click="selectDial(dialRow)"
                      >
                        <div class="inner" v-if="dialRow.dialResultText">
                          {{ dialRow.dialResultText }}
                        </div>
                        <div class="inner-graphic" v-if="dialRow.dialResultGraphic">
                          <img :class="dialRow.dialClass" :src="getDialImage(dialRow.dialResultGraphic)" />
                        </div>
                      </div>
                      <div v-if="dialRow.dialResultText !== 'EMPTY' && dialRow.dialName !== 'OR'" class="dialId">
                        {{ dialRow.dialName }}
                      </div>
                      <div v-if="dialRow.dialName === 'OR'" class="dialId or">{{ dialRow.dialName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </VueHtml2pdf>
      <div class="detail-info flex-column">
        <div class="header">
          <div class="title">{{ $t('pillar-details') }}</div>
          <div class="flex-row">
            <button style="margin-right: 15px" @click="generateReport">{{ $t('save-as-pdf') }}</button>
            <button
              v-if="showCollapse && pillarDetails.length > 1"
              class="small-btn"
              @click="collapseAll(pillarDetails)"
            >
              {{ $t('collapse-all') }}
            </button>
            <button
              class="small-btn"
              v-if="!showCollapse && pillarDetails.length > 1"
              @click="expandAll(pillarDetails)"
            >
              {{ $t('expand-all') }}
            </button>
          </div>
        </div>
        <div class="bottom-content flex-column" v-if="pillarDetails">
          <div class="pillar" v-for="pillar in pillarDetails" :key="pillar.pillarId">
            <div class="pillar-header subtitle" @click="pillar.show = !pillar.show">
              <div class="Performance" v-if="pillar.pillarIconSet === 'CFAFE Performance'">
                <Performance :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Training" v-else-if="pillar.pillarIconSet === 'CFAFE Training'">
                <Training :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Process" v-else-if="pillar.pillarIconSet === 'CFAFE Process'">
                <Process :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Facilities" v-else-if="pillar.pillarIconSet === 'CFAFE Facility'">
                <Facilities :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="EmployeeSurvey" v-else-if="pillar.pillarIconSet === 'CFAFE Survey'">
                <EmployeeSurvey :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}
              </div>
              <div class="Process" v-else><Process :class="pillar.pillarStatus" />{{ pillar.pillarTitle }}</div>
              <Carrot :class="pillar.show ? 'carrot-flipped' : 'carrot'" />
            </div>
            <div class="pillar-details flex-column" v-if="pillar.show">
              <div class="pillar-row" v-for="row in pillar.rows" :key="row.key">
                <div class="pillar-title">{{ row.pillarRowTitle }}</div>
                <div class="dial-container" v-for="dialRow in row.dials" :key="dialRow.key">
                  <div
                    class="smmt"
                    v-if="dialRow.dialTypeId === 'SMMT' || dialRow.dialTypeId === 'FDMT'"
                    @click="selectDial(dialRow)"
                  >
                    <IconProgress
                      v-if="dialRow.smmtProgress && (dialRow.dialTypeId === 'SMMT' || dialRow.dialTypeId === 'FDMT')"
                      :progress="dialRow.smmtProgress"
                      :targets="dialRow.smmtTargets"
                      :color="dialRow.dialColor"
                    />
                    <div class="circle" v-if="!dialRow.smmtProgress"></div>
                    <div class="smmtInner" v-if="dialRow.dialResultText">
                      {{ dialRow.dialResultText }}
                    </div>
                  </div>
                  <div
                    v-else-if="dialRow.dialResultText !== 'EMPTY' && dialRow.dialName !== 'OR'"
                    :class="['circle', dialRow.dialColor]"
                    @click="selectDial(dialRow)"
                  >
                    <div class="inner" v-if="dialRow.dialResultText">
                      {{ dialRow.dialResultText }}
                    </div>
                    <div class="inner-graphic" v-if="dialRow.dialResultGraphic">
                      <img :class="dialRow.dialClass" :src="getDialImage(dialRow.dialResultGraphic)" />
                    </div>
                  </div>
                  <div v-if="dialRow.dialResultText !== 'EMPTY' && dialRow.dialName !== 'OR'" class="dialId">
                    {{ dialRow.dialName }}
                  </div>
                  <div v-if="dialRow.dialName === 'OR'" class="dialId or">{{ dialRow.dialName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body" v-if="dialInfo">
        <div class="close" @click="isModalOpen = false"><Close /></div>
        <DialInfo :dialInfo="dialInfo" />
      </template>
    </Modal>
  </div>
</template>

<script>
import Tracker from '@/components/Tracker.vue';
import Periods from '@/components/Periods.vue';
import DialInfo from '@/components/DialInfo.vue';
import Performance from '@/assets/new/icon_performance.svg';
import Process from '@/assets/new/icon_process.svg';
import Training from '@/assets/new/icon_training.svg';
import EmployeeSurvey from '@/assets/new/icon_employee_survey.svg';
import Facilities from '@/assets/new/icon_facilities.svg';
import Carrot from '@/assets/icons/carrot_up.svg';
import Modal from '@/components/Modal.vue';
import Close from '@/assets/icons/x_icon_round.svg';
import IconProgress from '@/components/IconProgress.vue';
import VueHtml2pdf from 'vue-html2pdf';
import { mapState } from 'vuex';

export default {
  name: 'DealerDashboard',
  components: {
    DialInfo,
    Tracker,
    Periods,
    Facilities,
    Performance,
    Process,
    Training,
    EmployeeSurvey,
    Carrot,
    Modal,
    Close,
    IconProgress,
    VueHtml2pdf,
  },
  props: {
    trackerInfo: {
      type: Array,
    },
    pillarDetails: {
      type: Array,
    },
    messages: {
      type: Object,
    },
    selectedDealer: {
      type: Object,
    },
  },
  data() {
    return {
      isModalOpen: false,
      dialInfo: null,
      activeDial: null,
      periods: null,
      showTrackerContent: true,
      contentRendered: false,
      progress: 0,
      generatingPdf: false,
      pdfDownloaded: false,
    };
  },
  methods: {
    setActiveTab(newTab) {
      this.$store.state.activePeriod = newTab;
      this.getPillarInfoWithLoad();
    },
    selectDial(dial) {
      const { period, entity, domain } = this;
      const dialIdObj = dial.dialId;
      const dialId = dialIdObj;

      if (dial.dialColor === 'FI' || dial.dialColor === 'X' || dial.dialTypeId === 'SNM' || !dial.dialColor) {
        return;
      }
      const loader = this.$loading.show();
      this.$store.dispatch('getDial', { period, entity, dialId, domain }).then((res) => {
        this.isModalOpen = true;
        this.dialInfo = res[0];
        loader.hide();
      });
    },
    getDialImage(image) {
      if (this.imageTypeCheck(image)) {
        // eslint-disable-next-line import/no-dynamic-require
        return require(`@/assets/new/${image}?external`);
      }
      return null;
    },
    collapseAll(array) {
      array.forEach((pillar) => {
        this.$set(pillar, 'show', false);
      });
    },
    expandAll(array) {
      array.forEach((pillar) => {
        this.$set(pillar, 'show', true);
      });
    },
    imageTypeCheck(url) {
      return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress(progress) {
      this.progress = progress;
    },
    hasDownloaded() {
      this.pdfDownloaded = true;
    },
    setMessageVisibility(messages) {
      messages.forEach((message) => {
        const expirationTime = this.calculateExpiration(message);
        setTimeout(() => {
          window.location.reload();
        }, expirationTime);
      });
    },
    calculateExpiration(message) {
      const date1 = new Date(message.endDate);
      const timestamp2 = Date.now();
      const timestamp1 = Math.floor(date1.getTime());
      return timestamp1 - timestamp2;
    },
  },
  computed: {
    ...mapState('global', ['programStyle', 'programName']),
    ...mapState(['domainMessages', 'entityMessage', 'periodMessages', 'entityPeriodMessages', 'programBreadcrumb']),
    ...mapState({
      activeTab: 'activePeriod',
    }),
    domain() {
      return this.$route.params.domain;
    },
    entity() {
      return this.$route.params.entity;
    },
    period() {
      if (this.activeTab) {
        return this.activeTab.period;
      }
      return null;
    },
    checkPeriodMessages() {
      const index = this.periodMessages.findIndex((item) => item.period === this.period);
      return index >= 0;
    },
    checkEntityPeriodMessages() {
      const index = this.entityPeriodMessages.findIndex((item) => item.period === this.period);
      return index >= 0;
    },
    showCollapse() {
      if (this.pillarDetails) {
        const isEven = this.pillarDetails.every((pillar) => pillar.show);
        return isEven;
      }
      return false;
    },
  },
  watch: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  .dealer-top {
    display: flex;
    width: 100%;
    text-align: left;
    flex-direction: row;
    .trackers {
      padding: 50px;
      width: 100%;
    }
    .section-title {
      font-size: 21px;
      display: flex;
      padding-left: 10px;
    }
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      cursor: pointer;
    }
    .section {
      font-size: 18px;
      color: #1d1d1b;
      display: flex;
      align-items: center;
    }
    .section-small {
      color: #1d1d1b;
      font-size: 14px;
      padding-top: 15px;
      padding-left: 50px;
    }
    .section-icons {
      display: flex;
      padding-top: 20px;
      padding-left: 30px;
      svg {
        height: 35px;
        width: 35px;
        padding-right: 10px;
      }
      .icon-text {
        display: flex;
        align-items: center;
        padding: 0 20px;
        font-size: 12px;
        text-decoration: underline;
        color: #243882;
        cursor: pointer;
      }
      .cx_logo {
        width: 173px;
      }
    }
  }
  .bottom {
    .sticky-container {
      position: sticky;
      background: white;
      top: 0px;
      z-index: 2;
      .tab-container {
        display: flex;
        min-height: 40px;
        .tabs {
          display: flex;
          flex-direction: row;
          width: 100%;
          color: #1d1d1b;
          align-items: center;
          background-color: #d3d3d36c;
          justify-content: center;
          position: relative;
          padding-top: 5px;
          cursor: pointer;
          .pillar-icon {
            height: 35px;
            width: 35px;
            padding-right: 10px;
          }
          .incentive-icon {
            width: 24px;
            height: 24px;
            padding: 5px 5px 5px 15px;
          }
          &.active {
            background-color: #243882;
            color: white;
          }
        }
      }
      .status-info {
        background-color: #d3d3d36c;
        padding: 10px 40px;
        .description-container {
          display: flex;
        }
        .description {
          display: flex;
          color: #1d1d1b;
          font-size: 18px;
          padding-top: 20px;
          flex-basis: calc(20% - 0px);
          text-align: left;
          .Performance {
            svg {
              min-width: 42px !important;
              height: 42px !important;
              padding: 0 10px 5px 10px;
              filter: drop-shadow(0px 3px 6px #00000029);
              &.N {
                g {
                  circle {
                    fill: #8a8c8d;
                  }
                }
              }
              &.C {
                g {
                  circle {
                    fill: $fca-orange;
                  }
                }
              }
              &.P {
                g {
                  circle {
                    fill: #038717;
                  }
                }
              }
              &.F {
                g {
                  circle {
                    fill: #eb0001;
                  }
                }
              }
              &.X {
                g {
                  circle {
                    fill: #c4c5c6;
                  }
                }
              }
              &.FP {
                g {
                  circle {
                    fill: #597dd9;
                  }
                }
              }
              &.A {
                g {
                  circle {
                    fill: #e4bd35;
                  }
                }
              }
              &.I {
                g {
                  circle {
                    fill: #6d20be;
                  }
                }
              }
              &.L {
                g {
                  circle {
                    fill: #ff6261;
                  }
                }
              }
            }
          }
          .Training {
            svg {
              min-width: 60px !important;
              height: 60px !important;
              padding: 0 10px 5px 10px;
              filter: drop-shadow(0px 3px 6px #00000029);
              &.N {
                circle {
                  fill: #8a8c8d;
                }
                g {
                  circle {
                    fill: #8a8c8d;
                  }
                }
              }
              &.C {
                circle {
                  fill: $fca-orange;
                }
                g {
                  circle {
                    fill: $fca-orange;
                  }
                }
              }
              &.P {
                circle {
                  fill: #038717;
                }
                g {
                  circle {
                    fill: #038717;
                  }
                }
              }
              &.F {
                circle {
                  fill: #eb0001;
                }
                g {
                  circle {
                    fill: #eb0001;
                  }
                }
              }
              &.X {
                circle {
                  fill: #c4c5c6;
                }
                g {
                  circle {
                    fill: #c4c5c6;
                  }
                }
              }
              &.FP {
                circle {
                  fill: #597dd9;
                }
                g {
                  circle {
                    fill: #597dd9;
                  }
                }
              }
              &.A {
                circle {
                  fill: #e4bd35;
                }
                g {
                  circle {
                    fill: #e4bd35;
                  }
                }
              }
              &.I {
                circle {
                  fill: #6d20be;
                }
                g {
                  circle {
                    fill: #6d20be;
                  }
                }
              }
              &.L {
                circle {
                  fill: #ff6261;
                }
                g {
                  circle {
                    fill: #ff6261;
                  }
                }
              }
            }
          }
          .Process {
            svg {
              min-width: 60px !important;
              height: 60px !important;
              padding: 0 10px 5px 10px;
              filter: drop-shadow(0px 3px 6px #00000029);
            }
          }
          .Facilities {
            svg {
              min-width: 42px !important;
              height: 60px !important;
              padding: 0 10px 5px 10px;
              filter: drop-shadow(0px 3px 6px #00000029);
              &.N {
                path:nth-of-type(1) {
                  fill: #8a8c8d;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.C {
                path:nth-of-type(1) {
                  fill: $fca-orange;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.P {
                path:nth-of-type(1) {
                  fill: #038717;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.F {
                path:nth-of-type(1) {
                  fill: #eb0001;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.X {
                path:nth-of-type(1) {
                  fill: #c4c5c6;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.FP {
                path:nth-of-type(1) {
                  fill: #597dd9;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.A {
                path:nth-of-type(1) {
                  fill: #e4bd35;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.I {
                path:nth-of-type(1) {
                  fill: #6d20be;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
              &.L {
                path:nth-of-type(1) {
                  fill: #ff6261;
                }
                g {
                  path:nth-of-type(1) {
                    fill: #fff;
                  }
                }
              }
            }
          }
          .EmployeeSurvey {
            svg {
              min-width: 42px !important;
              height: 42px !important;
              padding: 0 10px 5px 10px;
              filter: drop-shadow(0px 3px 6px #00000029);
              &.N {
                g {
                  circle {
                    fill: #8a8c8d;
                  }
                }
              }
              &.C {
                g {
                  circle {
                    fill: $fca-orange;
                  }
                }
              }
              &.P {
                g {
                  circle {
                    fill: #038717;
                  }
                }
              }
              &.F {
                g {
                  circle {
                    fill: #eb0001;
                  }
                }
              }
              &.X {
                g {
                  circle {
                    fill: #c4c5c6;
                  }
                }
              }
              &.FP {
                g {
                  circle {
                    fill: #597dd9;
                  }
                }
              }
              &.A {
                g {
                  circle {
                    fill: #e4bd35;
                  }
                }
              }
              &.I {
                g {
                  circle {
                    fill: #6d20be;
                  }
                }
              }
              &.L {
                g {
                  circle {
                    fill: #ff6261;
                  }
                }
              }
            }
          }
          div {
            display: flex;
            align-items: center;
            svg {
              width: 60px !important;
              height: 60px !important;
              filter: drop-shadow(0px 3px 6px #00000029);
            }
          }
          div {
            svg {
              &.P {
                circle {
                  fill: #038717;
                }
              }
            }
          }
        }
      }
    }
  }
}
.performance-icon {
  width: 42px !important;
  height: 42px !important;
  padding: 0 10px 5px 10px;
  filter: drop-shadow(0px 3px 6px #00000029);
  &.P {
    g {
      circle {
        fill: green;
      }
    }
  }
}
.carrot {
  height: 12px !important;
  cursor: pointer;
  width: 24px;
  transform: rotate(90deg);
}
.carrot-flipped {
  height: 12px !important;
  cursor: pointer;
  transform: rotate(180deg);
  width: 24px;
}
.modal-body {
  display: flex;
  flex-direction: column;
  .close {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
}
.si-container {
  margin-left: 30px;
  text-align: left;
  color: red;
  font-weight: 600;
  p {
    margin: 20px 0;
  }
}
.dashLink {
  font-size: 14px;
  display: inline-block;
  background: #4f73d7;
  color: #fff;
  padding: 10px 5px;
  text-align: center;
  cursor: pointer;
  position: relative;
  width: 47.5%;
  max-width: 250px;
  text-decoration: none;
  border-style: none;
}
.subtitle {
  text-transform: uppercase;
}
.detail-info {
  padding: 40px;
  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.title {
  font-size: 21px;
  text-align: left;
  text-transform: uppercase;
}
.bottom-content {
  align-items: flex-start;

  svg {
    height: 60px;
    width: 60px;
  }
  .pillar {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 30px;
    svg {
      height: 60px;
      width: 60px;
    }
  }
  .pillar-header {
    display: flex;
    align-items: center;
    color: #1d1d1b;
    font-size: 18px;
    justify-content: space-between;
    width: 100%;
    cursor: pointer;
    div {
      display: flex;
      align-items: center;
    }
    div {
      svg {
        &.N {
          circle {
            fill: #8a8c8d;
          }
        }
        &.C {
          circle {
            fill: $fca-orange;
          }
        }
        &.P {
          circle {
            fill: #038717;
          }
        }
        &.F {
          circle {
            fill: #eb0001;
          }
        }
        &.X {
          circle {
            fill: #c4c5c6;
          }
        }
        &.FP {
          circle {
            fill: #597dd9;
          }
        }
        &.A {
          circle {
            fill: #e4bd35;
          }
        }
        &.I {
          path:nth-of-type(1) {
            fill: #6d20be;
          }
          g {
            path:nth-of-type(1) {
              fill: #fff;
            }
          }
          circle {
            fill: #6d20be;
          }
        }
        &.L {
          circle {
            fill: #ff6261;
          }
        }
      }
    }
  }
  .pillar-details {
    margin-top: 30px;
  }
  .pillar-row {
    display: flex;
    font-size: 18px;
    align-items: center;
    color: #1d1d1b;
    flex-wrap: wrap;
    margin-bottom: 30px;
    margin-left: 50px;
    .pillar-title {
      text-align: left;
      width: 100px;
    }
    .dial-container {
      display: flex;
      align-items: center;
      flex-basis: calc(20% - 20px);
      margin: 5px 15px;
    }
    .dialId {
      text-align: left;
      &.or {
        margin: 0 auto;
      }
    }
  }
}
.pdf-header {
  display: flex;
  justify-content: space-between;
  padding: 20px 10px;
  .right {
    color: #898c8d;
    text-align: right;
    justify-content: space-between;
    white-space: nowrap;
  }
  .title {
    font-size: 32px;
    font-weight: 500;
    text-transform: uppercase;
  }
}
.smmtInner-pdf {
  display: inline;
  position: relative;
  font-size: 14px;
  top: -45px;
  left: 20px;
}
</style>
